import React, { Fragment } from 'react'
import { H2, H3, H4 } from '@blueprintjs/core'
import moment from 'moment'
import 'moment/locale/fr'

const Header = ({ name, context, votesAmount }) => {

    let today = () => {
        let dayto = moment(Date.now())
        moment.locale('fr');
        return dayto.format('LL')
    }
    return (
        <Fragment>
            <div className='margin-top-large margin-bottom-large resultsQuestion'>
                <H2 className='text-center new-results'>Questions asked during session:</H2>
                <H3 className='text-center new-results'>{context}</H3>
            </div>
            <H4 className='margin-bottom-large margin-top-large text-center new-results'>{votesAmount} people votes (last updated {today()})</H4>
        </Fragment>
    )
}

export default Header
